import { initGsap } from './gsap'
import { initMqListener } from './breakpoint'
import ee from './ee'

import './components/article-hero'
import './components/homepage'
import './components/index-page'
import './components/lazyload'
import './components/lottie'
import './components/map'
import './components/menu'
import './components/modal'
import './components/newsletter-signup-form'
import './components/services'
import './components/stats'
import './components/quote'
import './components/search-results'
import './components/sections-fade-in'
import './components/site-head'
import './components/video'
import './components/video-full-width'

initGsap()

document.addEventListener('DOMContentLoaded', () => {
  initMqListener()
  ee.emit('initComponents')
})
